import { useEffect, useMemo, useState } from "react";

function serializeDebouncedValue<T>(value: T): string {
  if (value === null || value === undefined) return String(value);
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

/** Delays value updates — use for API/query keys while keeping UI state immediate. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  const valueKey = useMemo(() => serializeDebouncedValue(value), [value]);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [valueKey, delayMs, value]);

  return debounced;
}

export function isDebouncedValuePending<T>(current: T, debounced: T): boolean {
  return serializeDebouncedValue(current) !== serializeDebouncedValue(debounced);
}
